<template>
  <div class="data-card">
    <h3 class="mt-0 mb-3">Заказ</h3>
    <el-form :model="form" :rules="rules" ref="form" class="grid-table text-secondary" :class="[{ 'grid-table_border': !isEdited }]">
      <div class="grid-table__row">
        <div>
          <p class="mb-0">Статус заказа</p>
          <p class="text-blue pointer text-small mt-0" @click="showHistoryDialog = true">Посмотреть историю</p>
        </div>
        <OrderStatusDrop :disabled="!$isAccess($userRoles.Admin, $userRoles.Dispatcher)"/>
      </div>
      <div class="grid-table__row">
        <p>Номер заказа</p>
        <div>
          <el-form-item v-if="isEdited && $isAccess($userRoles.Admin)" prop="number">
            <el-input v-model="form.number" size="medium" />
          </el-form-item>
          <p v-else>{{ item.number }}</p>
        </div>
      </div>
      <div class="grid-table__row">
        <p>Тип заказа</p>
        <div>
          <el-form-item v-if="isEdited && $isAccess($userRoles.Admin)" prop="serviceId">
            <el-select v-model="form.serviceId" class="w-100" size="medium" filterable :loading="fetchServicesProgress">
              <el-option v-for="service in services" :key="service.id" :label="service.displayName" :value="service.id" />
            </el-select>
          </el-form-item>
          <p v-else>{{ item.service.displayName }}</p>
        </div>
      </div>
      <div class="grid-table__row">
        <p>Тип реестра</p>
        <el-form-item v-if="isEdited && $isAccess($userRoles.Admin, $userRoles.Dispatcher)" prop="registryTypeId">
          <el-select v-model="form.registryTypeId" class="w-100" size="medium" filterable :loading="registryTypesFetchProgress">
            <el-option v-for="option in registryTypesItemsFiltered" :key="option.id" :label="option.displayName" :value="option.id" />
          </el-select>
        </el-form-item>
        <p v-else>{{ item.registryType ? item.registryType.displayName : '' }}</p>
      </div>
      <div class="grid-table__row">
        <p>Детализация услуги</p>
        <div>
          <p>{{ item.serviceDetail }}</p>
        </div>
      </div>
      <div class="grid-table__row">
        <p>Дата оказания услуги</p>
        <div>
          <el-form-item v-if="isEdited && $isAccess($userRoles.Admin)" prop="workDate">
            <el-date-picker v-model="form.workDate" type="date" :clearable="false" value-format="yyyy-MM-dd" format="dd.MM.yyyy"
                            class="w-100" :pickerOptions="pickerOptions" />
          </el-form-item>
          <p v-else>{{ $moment.utc(item.workDate).format('DD.MM.YYYY') }}</p>
        </div>
      </div>
<!--      <div class="grid-table__row">-->
<!--        <p>Время сборки</p>-->
<!--        <div>-->
<!--          <el-form-item v-if="isEdited" prop="workTime">-->
<!--            <el-select class="w-100" v-model="form.workTime" placeholder="" size="medium">-->
<!--              <el-option v-for="option in workTimes" :key="option.value" :label="option.value" :value="option.value"></el-option>-->
<!--            </el-select>-->
<!--          </el-form-item>-->
<!--          <p v-else>{{ item.workTime }}</p>-->
<!--        </div>-->
<!--      </div>-->
    </el-form>

    <OrderStatusesHistoryDialog v-if="showHistoryDialog" :visible.sync="showHistoryDialog" :item="item" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { MESSAGES } from '@/commons/constants/errorMessages';
import OrderStatusDrop from '@/components/orders/drops/OrderStatusDrop';
import OrderStatusesHistoryDialog from '@/components/orders/dialogs/OrderStatusesHistoryDialog';
import workTimes from '@/commons/constants/workTimes';

const initialForm = () => ({
  number: '',
  serviceId: null,
  registryTypeId: null,
  serviceDetail: '',
  workDate: '',
  workTime: '',
});
export default {
  components: {
    OrderStatusDrop, OrderStatusesHistoryDialog,
  },
  props: {
    isEdited: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    workTimes,
    showHistoryDialog: false,
    form: initialForm(),
    rules: {
      number: [
        { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
        {
          required: true,
          max: 20,
          message: MESSAGES.MAX_LENGTH(20),
          trigger: 'change',
        },
      ],
      serviceId: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
      // serviceDetail: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
      workDate: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
      // workTime: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
    },
    pickerOptions: {
      firstDayOfWeek: 1,
      // disabledDate(time) {
      //   return time.getTime() < (new Date().getTime() - 1000 * 60 * 60 * 24);
      // },
    },
  }),
  created() {
    this.fetchServices();
    this.fetchRegistryTypes();
    this.fillForm();
  },
  computed: {
    ...mapGetters({
      item: 'orders/item',
      services: 'servicesDrop/items',
      fetchServicesProgress: 'servicesDrop/fetchProgress',
      registryTypesItems: 'registryTypesDrop/items',
      registryTypesFetchProgress: 'registryTypesDrop/fetchProgress',
    }),
    registryTypesItemsFiltered() {
      return this.registryTypesItems.filter((x) => !x.isArchived || x.id === this.item?.registryType?.id);
    },
  },
  methods: {
    ...mapActions({
      fetchServices: 'servicesDrop/fetchItems',
      fetchRegistryTypes: 'registryTypesDrop/fetchItems',
    }),
    fillForm() {
      if (this.item) {
        Object.keys(this.form)
          .forEach((key) => {
            switch (key) {
              case 'serviceId':
                this.form[key] = this.item.service?.id || null;
                break;
              case 'registryTypeId':
                this.form[key] = this.item.registryType?.id || null;
                break;
              default:
                this.form[key] = this.item[key];
            }
          });
      } else {
        this.form = initialForm();
      }
    },
    onSave() {
      let isValid = false;
      this.$refs.form.validate((valid) => {
        isValid = valid;
      });
      const form = {
        ...this.form,
      };
      return { isValid, form };
    },
  },
  watch: {
    item() {
      this.fillForm();
    },
  },
};
</script>
